var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search-view',{attrs:{"name":_vm.config.name,"config":_vm.config,"dataset":_vm.filter_data,"loading":_vm.loading},on:{"search":_vm.doSearch,"onchange":_vm.onDataChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }